import { lazy } from 'react';

const DashboardAnalytics = lazy(() =>
  import('../../views/dashboard/analytics')
);
const AccessControl = lazy(() => import('../../views/access-control'));

const DashboardRoutes = [
  {
    path: '/dashboard',
    element: <DashboardAnalytics />,
    meta: {
      permission: 'DASHBOARD'
    }
  },
  {
    path: '/access-control',
    element: <AccessControl />,
    meta: {
      permission: 'ACCESS_CONTROL',
      action: 'read',
      resource: 'ACL'
    }
  }
];

export default DashboardRoutes;
